import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../../utils/api/http';
import apiCoreHttp from '../../utils/api/apiCoreHttp';

export const getProducts = createAsyncThunk(
    'products/getProducts',
    async () => {
        const { data } = await http.get(`api/v1/products`);
        return data.data;
    },
);

export const getAvailableProducts = createAsyncThunk(
    'products/getAvailableProducts',
    async () => {
        const { data } = await apiCoreHttp.get(`api/v1/products/available`);
        return data;
    },
);

export const createProduct = createAsyncThunk(
    'products/createProduct',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.post('api/v1/product', body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const editProduct = createAsyncThunk(
    'products/editProduct',
    async ({ id, body }, { rejectWithValue }) => {
        try {
            const { data } = await http.put(`api/v1/product/${id}`, body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const deleteProduct = createAsyncThunk(
    'products/deleteProduct',
    async (id) => {
        await http.delete(`api/v1/product/${id}`);
    },
);

const initialState = {
    productsLoadingStatus: 'idle',
    availableProductsLoadingStatus: 'idle',
    products: [],
    availableProducts: [],
    errors: {},
};

export const productsSlice = createSlice({
    name: 'products',
    initialState,
    reducers: {},
    extraReducers: {
        [getProducts.pending]: (state, action) => {
            state.productsLoadingStatus = 'loading';
        },
        [getProducts.fulfilled]: (state, action) => {
            state.productsLoadingStatus = 'succeeded';
            state.products = action.payload;
        },
        [getProducts.rejected]: (state, action) => {
            state.productsLoadingStatus = 'failed';
        },
        [getAvailableProducts.pending]: (state, action) => {
            state.availableProductsLoadingStatus = 'loading';
        },
        [getAvailableProducts.fulfilled]: (state, action) => {
            state.availableProductsLoadingStatus = 'succeeded';
            state.availableProducts = action.payload;
        },
        [getAvailableProducts.rejected]: (state, action) => {
            state.availableProductsLoadingStatus = 'failed';
        },
    },
});

/* Selectors */
export const allProducts = (state) => state.products.products;
export const productsLoadingStatus = (state) =>
    state.products.productsLoadingStatus;
export const availableProducts = (state) => state.products.availableProducts;
export const availableProductsLoadingStatus = (state) =>
    state.products.availableProductsLoadingStatus;

export default productsSlice.reducer;
